import { INavStyles, IStackStyles } from "@fluentui/react";

export const containerStackStyles: IStackStyles = {
  root: {
    background: "#f2f2f2",
    width: "100%",
  },
  inner: {
    marginRight: "unset",
  },
};

export const iconStylesForStacksParent: Partial<INavStyles> = {
  root: {
    display: "inline-flex",
    verticalAlign: "middle",
    pointerEvents: "none",
    color: "#737373",
    marginRight: 6,
    paddingBottom:2,
    fontSize: 16,
  },
};

export const frencImageStyle: React.CSSProperties = {
  display: "inline-flex",
  verticalAlign: "middle",
  pointerEvents: "none",
  color: "#737373",
  marginRight: 6,
  fontSize: 16,
  paddingBottom: 3
};

export const iconStylesForStacks: Partial<INavStyles> = {
  root: {
    fontSize: ".6rem",
    display: "inline-block",
    verticalAlign: "middle",
    color: "#000000",
    pointerEvents: "none",
  },
};

export const textStyles: React.CSSProperties = {
  display: "inline-block",
  fontSize: "1rem",
  verticalAlign: "middle",
  alignItems: "center",
  justifyContent: "center",
  color: "rgb(0, 0, 0)",
  fontFamily:
    "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'sans-serif'",
};

export const firstStackStyles: IStackStyles = {
  root: {
    background: "#f2f2f2",
    margin: "0px 7% 0px 7%",
    padding: "2rem 0px 2rem 0px",
    selectors: {
      "@media screen and (min-width: 320px)": {
        maxWidth: 1920,
        width: "100%",
        marginLeft: 24,
      },
      "@media screen and (min-width: 860px)": {
        maxWidth: 1920,
        width: "100%",
        marginLeft: 24,
      },
      "@media screen and (min-width: 1084px)": {
        maxWidth: 1920,
        width: "100%",
        marginLeft: "5%",
      },
      "@media screen and (max-width: 767px)": {
        "> :first-child": {
          display: "grid",
        },
      },
    },
  },
  inner: {
    marginLeft: "unset",
  },
};

export const firstStackItemStyles: React.CSSProperties = {
  ...textStyles,
  background: "f2f2f2",
  marginLeft: "unset",
  marginRight: "2%",
  cursor: "pointer",
  textDecoration: "none",
};

export const stackStyles: IStackStyles = {
  root: {
    background: "#e3e3e3",
    width: "100%",
    height: 50,
    marginRight: "unset",
    "@media screen and (max-width: 600px)": {
      height: 130,
    },
  },
};

export const itemStyleLeft: React.CSSProperties = {
  fontSize: "1.2rem",
  lineHeight: "24px",
  fontFamily: "Segoe-UI",
  verticalAlign: "middle",
  color: "#000000",
  background: "transparent",
  display: "flex",
  justifyContent: "left",
  border: "1px solid #e3e3e3",
  marginLeft: "unset",
  width: "auto",
  paddingTop: 6,
};

export const itemStyles: React.CSSProperties = {
  alignItems: "center",
  background: "transparent",
  color: "#000000",
  justifyContent: "center",
  height: "35px",
  padding: "6px 0",
  border: "1px solid #e3e3e3",
  marginLeft: "unset",
  marginRight: "unset",
};

export const marginImgs: React.CSSProperties = {
  marginRight: 12,
};

export const marginLinkedIn: React.CSSProperties = {
  ...marginImgs,
  marginLeft: 12,
};

export const languageStyles: React.CSSProperties = {
  fontSize: "1rem",
  textDecoration: "none",
  marginRight: 4,
  padding: "5px 8px",
  background: "#e3e3e3",
  border: "2px dashed transparent",
  display: "inline-block",
};

export const englishStyles: React.CSSProperties = {
  ...languageStyles,
  marginRight: 4,
  borderRight: "1px solid #000000",
};

export const frenchStyles: React.CSSProperties = {
  ...languageStyles,
};

